module.exports = __webpack_public_path__ + "img/Group 125@2x.dda53d21.png";